// Path: ./src/contextApi/LoadingContext.tsx
// LoadingContext.tsx
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

interface LoadingProviderProps {
  children: React.ReactNode;
}

interface LoadingContextProps {
  isLoading: boolean;
  // eslint-disable-next-line no-unused-vars
  showLoadingScreen: (_state: boolean) => void;
}

const LoadingContext = createContext<LoadingContextProps | undefined>(
  undefined,
);

export const useLoading = (initialState = false) => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }

  const { showLoadingScreen } = context;
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      showLoadingScreen(initialState);
      isInitialRender.current = false;
    }
  }, [initialState, showLoadingScreen]);

  return context;
};

export const LoadingProvider: React.FC<LoadingProviderProps> = ({
  children,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoadingScreen = (state: boolean) => {
    setIsLoading(state);
  };

  return (
    <LoadingContext.Provider
      value={{ isLoading, showLoadingScreen }}
      data-testid="loadingprovider-test-id"
    >
      {children}
    </LoadingContext.Provider>
  );
};
